.row {
    display: flex;
    align-items: center;
}

.inlineStylesLevel0 {
    margin: 0px;
}
.inlineStylesLevel1 {
    margin: 0px 0px 0px 25px;
}
.inlineStylesLevel2 {
    margin: 0px 0px 0px 50px;
}
.inlineStylesLevel3 {
    margin: 0px 0px 0px 75px;
}

.inlineStylesNoArrowLevel0 {
    /* Width of arrow is 34px */
    margin: 0px 0px 0px 34px;
}
.inlineStylesNoArrowLevel1 {
    /* Width of arrow plus 25px of margin from inlineStylesLevel1 */
    margin: 0px 0px 0px 59px;
}
.inlineStylesNoArrowLevel2 {
    /* Width of arrow plus 50px of margin from inlineStylesLevel2 */
    margin: 0px 0px 0px 84px;
}
.inlineStylesNoArrowLevel3 {
    /* Width of arrow plus 75px of margin from inlineStylesLevel3 */
    margin: 0px 0px 0px 109px;
}

.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}